import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { WebsiteStateService } from '../../../../../state-management/services/website-state.service';
import { MatButtonModule } from '@angular/material/button';
import { AnalyticsService } from '../../../../../services/analytics.service';

@Component({
    selector: 'app-base-cards-contact',
    imports: [
        CommonModule,
        MatIconModule,
        MatButtonModule
    ],
    templateUrl: './base-cards-contact.component.html',
    styleUrl: './base-cards-contact.component.scss'
})
export class BaseCardsContactComponent {
  public configuration = this.websiteState.configuration;

  constructor(
    private analyticsService: AnalyticsService,
    private websiteState: WebsiteStateService ) { }



  sendEmail() {
    this.analyticsService.trackContactIntent('email', 'contact_email_button');
    let email = this.configuration().contactData.email;
    window.location.href = `mailto:${email}`;
  }

  call() {
    this.analyticsService.trackContactIntent('phone', 'contact_phone_button');
    let phone = this.configuration().contactData.phone;
    window.location.href = `tel:${phone}`;
  }

}
